import { lazy, Suspense, useEffect, useContext } from 'react';
/// Components
import { connect, useDispatch } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams, Outlet } from 'react-router-dom';
/// Style
import './other/swiper/css/swiper-bundle.min.css';
import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import "./jsx/index.css";
import "./jsx/chart.css";
import "./jsx/step.css";

/// Layout
import Nav from "./jsx/layouts/nav";
import Footer from "./jsx/layouts/Footer";
import ScrollToTop from "./jsx/layouts/ScrollToTop";
/// Dashboard
import Users from "./jsx/pages/User";

/// Pages
import LockScreen from "./jsx/pages/LockScreen";
import Error400 from "./jsx/pages/Error400";
import Error403 from "./jsx/pages/Error403";
import Error404 from "./jsx/pages/Error404";
import Error500 from "./jsx/pages/Error500";
import Error503 from "./jsx/pages/Error503";
import Setting from "./jsx/layouts/Setting";
import { ThemeContext } from "./context/ThemeContext";
import Login from "./jsx/pages/Login";
import EmailVerification from "./jsx/pages/emailVerification";
import {loginSync} from "./store/actions/login.action";
import {userMount} from "./store/actions/mount.action";
import UserProfile from "./jsx/pages/UserProfile";
import ForgotPassword from "./jsx/pages/ForgotPassword";
import ResetPassword from "./jsx/pages/ResetPassword";
import Organizations from "./jsx/pages/Organizations";
import LedgerHistory from "./jsx/pages/LedgerHistory";
import Main from "./jsx/pages/Main";
import useGetData from "./hooks/useGetData"
import Ledger from "./jsx/pages/Ledger";
import {getActiveOrganizationsAsync} from "./store/actions/organization.action";
import LedgerManage from "./jsx/pages/LedgerManage";

function App ({loginFunc,userMountFunc,login,mount,getOrgFunc}) {

    let isLogin =  localStorage.getItem("isLogin");
    let first_name =  localStorage.getItem("first_name");
    let last_name =  localStorage.getItem("last_name");
    let user_id =  localStorage.getItem("user");
    let user_role =  localStorage.getItem("user_role");

    useEffect(() => {
        setTimeout( async () => {
            if(user_id !== null){
                if((/true/).test(isLogin)){
                    loginFunc()
                }
            }else{
                userMountFunc()
            }
        }, 5);
    }, []);

    useEffect(() => {
        if(mount.status){
            if(login.isLogin){
                setTimeout(()=>{
                    getOrgFunc()
                },1000)
            }
        }
    }, [login,mount]);


    return (
        <>
            <Suspense fallback={
                <div id="preloader">
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                    </div>
                </div>
               }
            >
                <Routes>
                    <Route path='/page-error-400' element={<Error400 />} />
                    <Route path='/page-error-403' element={<Error403 />} />
                    <Route path='/page-error-404' element={<Error404 />} />
                    <Route path='/page-error-500' element={<Error500 />} />
                    <Route path='/page-error-503' element={<Error503 />} />
                    <Route path='/page-lock-screen' element={<LockScreen />} />
                    <Route path='/login' exact element={<Login/>} />
                    <Route path='/email-verification/:user' exact element={<EmailVerification/>} />
                    <Route path='/email-verification' exact element={<EmailVerification/>} />
                    <Route path='/forgot-password' exact element={<ForgotPassword/>} />
                    <Route path='/confirm-password' exact element={<ResetPassword/>} />
                    <Route path='/confirm-password/:user' exact element={<ResetPassword/>} />
                    <Route element={<Layout1 />}>
                        <Route path='/' exact element={<Main/>} />
                        <Route path='/users' exact element={<Users/>} />
                        <Route path='/ledger' exact element={<Ledger/>} />
                        <Route path='/ledger-history' exact element={<LedgerHistory/>} />
                        <Route path='/ledger-manage' exact element={<LedgerManage/>} />
                        <Route path='/organizations' exact element={<Organizations/>} />
                        <Route path='/profile' exact element={<UserProfile/>} />
                    </Route>

                </Routes>
                {/*<Setting/>*/}
                <ScrollToTop />
                {/*<Index />*/}
            </Suspense>
        </>
    );
};

function Layout1(){
    const { menuToggle, sidebariconHover } = useContext(ThemeContext);
    return(

        <div id="main-wrapper" className={`wallet-open active show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>
            <Nav />
            <div className="content-body" style={{ minHeight: window.screen.height + 20 }}>
                <div className="container-fluid">
                    <Outlet />
                    <Footer />
                </div>
            </div>
            <div className="wallet-bar-close"></div>
        </div>

    )
}

const initMapDispatchToProps = dispatch => ({
    loginFunc: (data,tkn) => dispatch(loginSync(data,tkn)),
    userMountFunc: () => dispatch(userMount()),
    getOrgFunc: () => dispatch(getActiveOrganizationsAsync()),
})

const mapStateToProps = state => ({
    login: state.auth,
    mount: state.mount,
    org: state.org
})

export default connect(mapStateToProps,initMapDispatchToProps)(App);